import React from 'react';

type Props = {
  open: boolean;
  title?: string;
  message: string;
  onClose: () => void;
  onRetry?: () => void;
  onRelogin?: () => void;
  requiresRelogin?: boolean;
};

const ServiceUnavailableModal: React.FC<Props> = ({
  open,
  title = 'Service unavailable',
  message,
  onClose,
  onRetry,
  onRelogin,
  requiresRelogin = false,
}) => {
  if (!open) return null;

  return (
    <div className="zivo-global-modal-overlay" role="presentation">
      <div
        className="zivo-global-modal-content"
        role="dialog"
        aria-modal="true"
        aria-label={title}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="zivo-global-modal-header">
          <h3>{title}</h3>
        </div>
        <div className="zivo-global-modal-body">
          <p>{message}</p>
        </div>
        <div className="zivo-global-modal-footer" style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          {requiresRelogin ? (
            <button className="zivo-global-modal-button" onClick={onRelogin || onClose} type="button">
              OK
            </button>
          ) : (
            <>
              <button className="zivo-global-modal-button" onClick={onRetry || onClose} type="button">
                Retry
              </button>
              <button className="zivo-global-modal-button" onClick={onClose} type="button">
                Close
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ServiceUnavailableModal;

